module.exports = __webpack_public_path__ + "img/ico-threads-circle.6a1d0333.svg";